(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisDeleteController',RootCauseAnalysisDeleteController);

    RootCauseAnalysisDeleteController.$inject = ['$uibModalInstance', 'entity', 'RootCauseAnalysis'];

    function RootCauseAnalysisDeleteController($uibModalInstance, entity, RootCauseAnalysis) {
        var vm = this;

        vm.rootCauseAnalysis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RootCauseAnalysis.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
